import { ao as b, a as _, c as d, e as u, g as o, h as c, z as h, ay as g, t as M, k as q, an as m } from "./define-element-XpjsV6s1.js";
import { _ as r } from "./Icon-CGbhZCm-.js";
import { _ as N } from "./_plugin-vue_export-helper-CHgC5LLL.js";
const V = { class: "offset-quantity-select-wrapper" }, k = { class: "offset-quantity-select" }, Q = ["disabled"], B = ["disabled"], C = ["disabled"], I = {
  key: 0,
  class: "offset-quantity-exceeded",
  role: "alert"
}, D = {
  __name: "QuantitySelect",
  props: /* @__PURE__ */ m({
    disabled: {
      type: Boolean,
      default: !1
    },
    max: {
      type: Number,
      default: 36
    },
    min: {
      type: Number,
      default: 0
    },
    // Suppresses the inline "Quantity cannot exceed" message below — for a
    // caller (Cart.vue) that already surfaces a more prominent warning via
    // "max-exceeded" and doesn't want both shown at once.
    hideExceededMessage: {
      type: Boolean,
      default: !1
    }
  }, {
    modelValue: 1,
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ m(["change", "max-exceeded"], ["update:modelValue"]),
  setup(i, { emit: f }) {
    const s = b(i, "modelValue", 1), n = f, e = i, t = _(!1);
    function p() {
      t.value = !1, n("change", Math.max(e.min, s.value - 1));
    }
    function x() {
      const l = parseInt(s.value, 10) + 1;
      if (l > e.max) {
        t.value = !0, n("change", e.max), n("max-exceeded", e.max);
        return;
      }
      t.value = !1, n("change", l);
    }
    function v(l) {
      let a = parseInt(l.target.value, 10);
      isNaN(a) || a < e.min ? (a = Math.max(e.min, 1), t.value = !1) : a > e.max ? (a = e.max, t.value = !0) : t.value = !1, n("change", a), t.value && n("max-exceeded", e.max);
    }
    return (l, a) => (d(), u("div", V, [
      o("div", k, [
        o("button", {
          type: "button",
          class: "offset-quantity-button",
          "aria-label": "Decrease quantity",
          onClick: p,
          disabled: e.disabled || s.value <= e.min
        }, [
          c(r, { name: "minus" })
        ], 8, Q),
        h(o("input", {
          type: "text",
          inputmode: "numeric",
          size: "2",
          autocomplete: "off",
          "aria-label": "Quantity",
          class: "offset-quantity-input",
          "onUpdate:modelValue": a[0] || (a[0] = (y) => s.value = y),
          onChange: v,
          disabled: e.disabled
        }, null, 40, B), [
          [
            g,
            s.value,
            void 0,
            { number: !0 }
          ]
        ]),
        o("button", {
          type: "button",
          class: "offset-quantity-button",
          "aria-label": "Increase quantity",
          onClick: x,
          disabled: e.disabled || s.value >= e.max
        }, [
          c(r, { name: "plus" })
        ], 8, C)
      ]),
      t.value && !e.hideExceededMessage ? (d(), u("div", I, " Quantity cannot exceed " + M(e.max) + ". ", 1)) : q("", !0)
    ]));
  }
}, z = /* @__PURE__ */ N(D, [["__scopeId", "data-v-1e8d13e3"]]);
export {
  z as Q
};
